export const COVER_PAGE_ERROR = {
  key: 'coverPageError',
  value: 'Your cover page image could not be found. Please select another one to continue.',
};
export const SUBURB_INSIGHTS_ERROR = {
  key: 'suburbInsightsError',
  value: 'Failed to load suburb insights.',
};

export const getReportErrorMessages = (state) => {
  const reportType = state.reportType?.value || 'cma';
  const errorMsgs = [];
  if (!checkCoverPageImages(state.coverPageImages, reportType)) {
    errorMsgs.push(COVER_PAGE_ERROR);
  }
  if (!checkSuburbInsights(state.propertyDetail)) {
    errorMsgs.push(SUBURB_INSIGHTS_ERROR);
  }
  return errorMsgs;
};

export const checkCoverPageImages = (coverPageImages, reportType) => {
  const selections = coverPageImages?.selections || {};
  return !selections[reportType]?.invalidImage;
};

export const checkSuburbInsights = (propertyDetail) => {
  const suburbInsights = propertyDetail?.suburbInsights || {};
  const keys = Object.keys(suburbInsights);
  return keys.some(k => k !== 'isLoading');
};

const ValidationUtilsLib = {
  COVER_PAGE_ERROR,
  SUBURB_INSIGHTS_ERROR,
  checkCoverPageImages,
  checkSuburbInsights,
  getReportErrorMessages,
};
export default ValidationUtilsLib;
